export const FETCH_COMPONENTS_HI_STARTED = "FETCH_DEFECTS_STARTED";
export const FETCH_COMPONENTS_HI_SUCCESS = "FETCH_DEFECTS_SUCCESS";

const initialState = {
  data: [],
  loading: true,
};

const ComponentsHIReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_COMPONENTS_HI_STARTED:
      return { ...state, loading: true };
    case FETCH_COMPONENTS_HI_SUCCESS:
      return { ...state, data: action.data, loading: false };
    default:
      return state;
  }
};

export { ComponentsHIReducer };
